import * as React from "react"
import type { SVGProps } from "react"
const SvgArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.86q-.82 0-1.41-.59A2 2 0 0 1 3 20.86V9.58q-.45-.27-.72-.71A2 2 0 0 1 2 7.86v-3q0-.83.59-1.41A2 2 0 0 1 4 2.85h16q.83 0 1.41.6.6.59.59 1.4v3q0 .59-.28 1.02-.27.45-.72.71v11.28q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm0-13v11h14v-11zm-1-2h16v-3H4zm6 7h4q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28h-4a1 1 0 0 0-.71.28 1 1 0 0 0-.29.72q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgArchive
